// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		//Call function with browser is resized.
		$(window).resize(function (event) {
			//
		});

		// RELLAX
		if ( document.querySelector('.js-rellax') ) {
			const rellax = new Rellax('.js-rellax', {
				center: true
			});
		}

		// SHOW/HIDE TARGET ON CLICK
		document.querySelectorAll('.js-toggleTarget').forEach(btn => {
			const currentTarget = btn.getAttribute('href');
			btn.addEventListener('click', e => {
				e.preventDefault();
				document.querySelector( currentTarget ).classList.toggle('active');
			});
		});

		// SPLIT CURSIVE TITLE TEXT
		document.querySelectorAll('.titles > span').forEach(span => {
			const chars = span.textContent.split('').map(char => `<span class="char">${char}</span>`).join('');
			span.innerHTML = chars;
		});


		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

        // INNER PAGES HEADER SPACE
        if ( (document.body.id !== 'home' && document.body.id !== 'landing-page') && document.getElementById('start-content') ) {
            document.getElementById('start-content').style.paddingTop = `${document.getElementById('header').offsetHeight}px`;
        }

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		document.getElementById('header').classList.add('scroll');
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		document.getElementById('header').classList.remove('scroll');
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}